

export const showDataSourceStatusConstants = {
    GET_ALL_REQUEST: 'GET_ALL_DATA_SOURCES_STATUS_REQUEST',
    GET_ALL_SUCCESS: 'GET_ALL_DATA_SOURCES_STATUS_SUCCESS',
    GET_ALL_FAILURE: 'GET_ALL_DATA_SOURCES_STATUS_FAILURE',

}